import { DROPDOWN_ITEM_CLICK } from '@amzn/carrierlogistics-commons/dist/constants/analytics';
import {
  useAuthorisedDSPs,
  useAuthorisedLps,
  useSelectedLp,
} from '@amzn/carrierlogistics-commons/dist/hooks/authorisation/index';
import { recordCustomEventInCloudWatchRUM } from '@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum';
import { isDSPFeatureEnabled } from '@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature';
import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { LP_SELECT_DROPDOWN_ITEM_CLICK } from '../constants/analytics';
import { MONS_DIRECTOR_ID_QUERY_PARAM } from '../constants/externalPassportUIConstants';
import windowUtil from '../utils/window';

export const useLpSelectActions = () => {
  const authorizedLps = useAuthorisedLps();
  const authorizedDeliverServiceProviders = useAuthorisedDSPs();
  const authorizedDSPs = isDSPFeatureEnabled()
    ? authorizedDeliverServiceProviders
    : [];

  const lpSelected = useSelectedLp();
  const [searchQuery, setSearchQuery] = useState('');

  const setLpSelected = useCallback(value => {
    const searchParams = new URLSearchParams(windowUtil.location.search);
    searchParams.set(MONS_DIRECTOR_ID_QUERY_PARAM, value);
    recordCustomEventInCloudWatchRUM(DROPDOWN_ITEM_CLICK, {
      action_properties: {
        name: LP_SELECT_DROPDOWN_ITEM_CLICK,
      },
      extra_properties: {
        lpId: value,
      },
    });
    windowUtil.location.search = searchParams.toString();
  }, []);

  return {
    lpData: searchQuery
      ? authorizedLps.filter(({ logisticsPartyDisplayName }) =>
          logisticsPartyDisplayName
            ?.toLowerCase()
            ?.includes(searchQuery.toLowerCase())
        )
      : authorizedLps,
    dspData: searchQuery
      ? authorizedDSPs.filter(({ logisticsPartyDisplayName }) =>
          logisticsPartyDisplayName
            ?.toLowerCase()
            ?.includes(searchQuery.toLowerCase())
        )
      : authorizedDSPs,
    lpIdSelected:
      isEmpty(authorizedLps) || isEmpty(lpSelected?.directedLpId)
        ? ''
        : lpSelected.directedLpId,
    setLpSelected,
    searchQuery,
    setSearchQuery,
  };
};
export default useLpSelectActions;
